// React Basic and Bootstrap
import React, { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Link } from 'react-router-dom';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Container,
  Row,
} from 'reactstrap';

// v3 Screenshots
import ImageDiscover from '../../assets/images/v3/discover.png';
import ImageWritingHelper from '../../assets/images/v3/writing_helper.png';
import ImageQuiz from '../../assets/images/v3/quiz.png';
import ImageWordOfDay from '../../assets/images/v3/word_of_day_notification.png';
import ImageDashboard from '../../assets/images/v3/dashboard.png';

import ImageAppStore from '../../assets/images/app_store_badge_564x168.png';
import ImageGooglePlay from '../../assets/images/google_play_badge_trimmed_564x168.png';

import BackToTop from '../../components/Layout/backToTop';
import { FREE_VERSION } from '../../config';
import Pricing from './Pricing';
import Testi from './Testi';
import Section from './Section';
import ExtensionDemo from '../../components/Shared/ExtensionDemo';


const Index = () => {
  useEffect(() => {
    document.body.classList = '';
    window.addEventListener('scroll', scrollNavigation, true);
  });

  const scrollNavigation = () => {
    var doc = document.documentElement;
    const navBar = document.getElementById('topnav');
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    if (navBar != null) {
      if (top > 80) {
        navBar.classList.add('nav-sticky');
      } else {
        navBar.classList.remove('nav-sticky');
      }
    }
  };

  const [col1, setCol1] = useState(false);
  const [col2, setCol2] = useState(false);
  const [col3, setCol3] = useState(false);
  const [col4, setCol4] = useState(false);
  const [col5, setCol5] = useState(false);

  return (
    <React.Fragment>
      <Section />

      <div className="position-relative">
        <div className="shape overflow-hidden text-light">
          <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor" />
          </svg>
        </div>
      </div>

      {/* Feature 0 — FEATURED: Interactive demo (try it yourself) */}
      <div
        style={{
          background: 'linear-gradient(135deg, #f0fdf8 0%, #eef4ff 100%)',
          borderTop: '1px solid rgba(11, 138, 117, 0.1)',
          borderBottom: '1px solid rgba(11, 138, 117, 0.1)',
          padding: '48px 0',
        }}
      >
        <Container>
          <Row className="justify-content-center mb-4">
            <Col lg={8} md={10} className="text-center">
              <span
                className="badge rounded-pill mb-3 d-inline-block"
                style={{
                  background: 'linear-gradient(135deg, #d1fae5, #a7f3d0)',
                  color: '#065f46',
                  fontSize: '0.78rem',
                  fontWeight: 700,
                  letterSpacing: '0.06em',
                  padding: '0.45rem 0.9rem',
                  textTransform: 'uppercase',
                  border: '1px solid rgba(16, 185, 129, 0.2)',
                }}
              >
                Most Helpful Feature
              </span>
              <h4 className="title mb-3" style={{ fontSize: '1.6rem' }}>
                Save a Word, See It Everywhere
              </h4>
              <p className="sec-title mb-0" style={{ maxWidth: 600, margin: '0 auto' }}>
                Click an underlined word below to see its definition, then save it. It highlights instantly and lands in your word list — just like it would on any page you browse.
              </p>
            </Col>
          </Row>
          <Row className="justify-content-center mt-2">
            <Col lg={12}>
              <ExtensionDemo />
            </Col>
          </Row>
        </Container>
      </div>

      {/* Feature 1 — Discover (image right) */}
      <Container className="mt-100 mt-60 px-4 px-md-3 px-lg-0">
        <Row className="align-items-center g-4 g-md-5">
          <Col lg={6} md={6} className="order-2 order-md-1">
            <p className="feature-eyebrow">Discover</p>
            <h4 className="feature-title">50,000 Words, Ready to Explore</h4>
            <p className="feature-desc">
              Browse our curated library of 50,000 English words — each with a clear definition, real example sentences, and full word details. Filter by topic or CEFR level (A1–C2) to find exactly the words you need, then save any of them to your list with one tap.
            </p>
          </Col>
          <Col lg={6} md={6} className="order-1 order-md-2">
            <img src={ImageDiscover} className="feature-img" alt="Discover words by topic and level" />
          </Col>
        </Row>
      </Container>

      {/* Feature 2 — Quiz (image left) */}
      <Container className="mt-100 mt-60 px-4 px-md-3 px-lg-0">
        <Row className="align-items-center g-4 g-md-5">
          <Col lg={6} md={6}>
            <img src={ImageQuiz} className="feature-img" alt="Quiz with multiple-choice questions" />
          </Col>
          <Col lg={6} md={6}>
            <p className="feature-eyebrow">Practice</p>
            <h4 className="feature-title">Quiz Yourself on What You Saved</h4>
            <p className="feature-desc">
              Answer multiple-choice questions from your own word list. See your score, review what you missed, and repeat daily to lock words in.
            </p>
          </Col>
        </Row>
      </Container>

      {/* Feature 3 — Writing Helper (image right) */}
      <Container className="mt-100 mt-60 px-4 px-md-3 px-lg-0">
        <Row className="align-items-center g-4 g-md-5">
          <Col lg={6} md={6} className="order-2 order-md-1">
            <p className="feature-eyebrow">AI Writing Help</p>
            <h4 className="feature-title">Write Clearer, More Natural English</h4>
            <p className="feature-desc">
              Paste any sentence to get a cleaner, more natural version. Or describe what you want to say — HighVocab writes it for you.
            </p>
          </Col>
          <Col lg={6} md={6} className="order-1 order-md-2">
            <img src={ImageWritingHelper} className="feature-img" alt="Writing helper fixing and composing sentences" />
          </Col>
        </Row>
      </Container>

      {/* Feature 4 — Notification (image left) */}
      <Container className="mt-100 mt-60 px-4 px-md-3 px-lg-0">
        <Row className="align-items-center g-4 g-md-5">
          <Col lg={6} md={6}>
            <img src={ImageWordOfDay} className="feature-img" alt="Word of the day notification popup" />
          </Col>
          <Col lg={6} md={6}>
            <p className="feature-eyebrow">Daily Reminder</p>
            <h4 className="feature-title">A Gentle Nudge to Practice Every Day</h4>
            <p className="feature-desc">
              A small reminder appears while you browse so you never skip a day. No apps to open — it meets you where you already are.
            </p>
          </Col>
        </Row>
      </Container>

      {/* Mobile app section */}
      <div
        className="mt-100 mt-60"
        style={{
          background: 'linear-gradient(135deg, #f5f3ff 0%, #eef4ff 100%)',
          borderTop: '1px solid rgba(139,92,246,0.1)',
          borderBottom: '1px solid rgba(139,92,246,0.1)',
          padding: '64px 0',
        }}
      >
        <Container>
          {/* Text header */}
          <Row className="justify-content-center text-center mb-5">
            <Col lg={7} md={9}>
              <span
                style={{
                  display: 'inline-block',
                  background: 'rgba(139,92,246,0.1)',
                  color: '#7c3aed',
                  fontSize: '0.75rem',
                  fontWeight: 700,
                  letterSpacing: '0.09em',
                  borderRadius: 999,
                  padding: '4px 14px',
                  textTransform: 'uppercase',
                  marginBottom: 16,
                  border: '1px solid rgba(139,92,246,0.18)',
                }}
              >
                Now on Mobile
              </span>
              <h2 style={{ fontWeight: 700, color: '#0f172a', fontSize: 'clamp(1.6rem, 2.4vw, 2.2rem)', marginBottom: 12 }}>
                Take HighVocab Everywhere
              </h2>
              <p style={{ color: '#64748b', fontSize: '1.05rem', lineHeight: 1.7, marginBottom: 0 }}>
                Your saved words, quizzes, and word details — now in your pocket. Point your camera at the QR code to download instantly.
              </p>
            </Col>
          </Row>

          {/* QR cards */}
          <Row className="justify-content-center g-4">
            {/* iOS */}
            <Col xs={11} sm={8} md={5} lg={4}>
              <div
                style={{
                  background: '#fff',
                  border: '1px solid rgba(139,92,246,0.15)',
                  borderRadius: 24,
                  boxShadow: '0 8px 32px rgba(15,23,42,0.08)',
                  padding: '32px 28px 24px',
                  textAlign: 'center',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: 20 }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="#0f172a" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                  </svg>
                  <span style={{ fontWeight: 700, color: '#0f172a', fontSize: '0.95rem' }}>iOS</span>
                </div>
                <div style={{ display: 'inline-block', padding: 12, background: '#f8fafc', borderRadius: 16, border: '1px solid rgba(15,23,42,0.06)' }}>
                  <QRCodeSVG
                    value="https://apps.apple.com/us/app/highvocab/id6770623659"
                    size={160}
                    bgColor="#f8fafc"
                    fgColor="#0f172a"
                    level="M"
                  />
                </div>
                <div style={{ marginTop: 20 }}>
                  <a
                    href="https://apps.apple.com/us/app/highvocab/id6770623659"
                    target="_blank"
                    rel="noreferrer"
                    style={{ display: 'inline-block', lineHeight: 0 }}
                  >
                    <img src={ImageAppStore} alt="Download on the App Store" style={{ height: 44, width: 'auto' }} />
                  </a>
                </div>
              </div>
            </Col>

            {/* Android */}
            <Col xs={11} sm={8} md={5} lg={4}>
              <div
                style={{
                  background: '#fff',
                  border: '1px solid rgba(139,92,246,0.15)',
                  borderRadius: 24,
                  boxShadow: '0 8px 32px rgba(15,23,42,0.08)',
                  padding: '32px 28px 24px',
                  textAlign: 'center',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: 20 }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="#3ddc84" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.523 15.341A5.98 5.98 0 0 0 18 13a5.98 5.98 0 0 0-.477-2.341l2.315-1.338a9 9 0 0 1 0 7.358l-2.315-1.338zM13 20.94V18a5.985 5.985 0 0 1-2-.341l-1.338 2.315A9.016 9.016 0 0 0 13 20.94zm-2.477-.966L9.185 17.66A5.98 5.98 0 0 1 7.523 15.341L5.208 16.68a9 9 0 0 0 5.315 3.294zM6 13a5.98 5.98 0 0 0 .477 2.341L4.162 16.68a9 9 0 0 1 0-7.358l2.315 1.338A5.98 5.98 0 0 0 6 13zm1.523-2.341L5.208 9.32a9.016 9.016 0 0 1 5.315-3.294L9.185 8.34A5.985 5.985 0 0 0 7.523 10.66zM11 5.06v2.94a5.985 5.985 0 0 1 2 .341l1.338-2.315A9.016 9.016 0 0 0 11 5.06zm2.477.966L14.815 8.34A5.98 5.98 0 0 1 16.477 10.66l2.315-1.338a9 9 0 0 0-5.315-3.296zM12 15a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"/>
                  </svg>
                  <span style={{ fontWeight: 700, color: '#0f172a', fontSize: '0.95rem' }}>Android</span>
                </div>
                <div style={{ display: 'inline-block', padding: 12, background: '#f8fafc', borderRadius: 16, border: '1px solid rgba(15,23,42,0.06)' }}>
                  <QRCodeSVG
                    value="https://play.google.com/store/apps/details?id=com.highvocab.app"
                    size={160}
                    bgColor="#f8fafc"
                    fgColor="#0f172a"
                    level="M"
                  />
                </div>
                <div style={{ marginTop: 20 }}>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.highvocab.app"
                    target="_blank"
                    rel="noreferrer"
                    style={{ display: 'inline-block', lineHeight: 0 }}
                  >
                    <img src={ImageGooglePlay} alt="Get it on Google Play" style={{ height: 44, width: 'auto' }} />
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Feature 5 — Dashboard (full-width, title on top) */}
      <div
        className="mt-100 mt-60"
        style={{
          background: 'linear-gradient(135deg, #eef4ff 0%, #f5f0ff 100%)',
          borderTop: '1px solid rgba(139, 92, 246, 0.1)',
          borderBottom: '1px solid rgba(139, 92, 246, 0.1)',
          padding: '48px 0',
        }}
      >
        <Container>
          <Row className="justify-content-center mb-4">
            <Col lg={8} md={10} className="text-center">
              <span
                className="badge rounded-pill mb-3 d-inline-block"
                style={{
                  background: 'linear-gradient(135deg, #ede9fe, #ddd6fe)',
                  color: '#5b21b6',
                  fontSize: '0.78rem',
                  fontWeight: 700,
                  letterSpacing: '0.06em',
                  padding: '0.45rem 0.9rem',
                  textTransform: 'uppercase',
                  border: '1px solid rgba(139, 92, 246, 0.2)',
                }}
              >
                Your Learning Hub
              </span>
              <h4 className="title mb-3" style={{ fontSize: '1.6rem' }}>
                Everything in One Clean View
              </h4>
              <p className="sec-title mb-0" style={{ maxWidth: 600, margin: '0 auto' }}>
                Track your progress, review saved words, and access every feature from a single dashboard — organized and ready whenever you are.
              </p>
            </Col>
          </Row>
          <Row className="justify-content-center mt-2">
            <Col xs={12}>
              <img
                src={ImageDashboard}
                alt="HighVocab dashboard overview"
                style={{
                  width: '100%',
                  borderRadius: 16,
                  border: '1px solid rgba(139, 92, 246, 0.25)',
                  boxShadow: '0 8px 28px rgba(15, 23, 42, 0.09)',
                  display: 'block',
                }}
              />
            </Col>
          </Row>
        </Container>
      </div>

      {!FREE_VERSION && <Pricing />}

      <section className="section pt-0" id="highvocab-faq">
        <Container className="mt-100 mt-60 md-padding-20">
          <Row className="justify-content-center">
            <Col xs={12} className="text-center">
              <div className="section-title">
                <h4 className="title mb-4">Common Questions</h4>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col lg={9} className="mt-4 pt-2">
              <div className="faq-content">
                <div className="accordion" id="accordionExample">
                  <Card className="border-0 rounded mb-2">
                    <Link
                      to="#"
                      onClick={() => setCol1(!col1)}
                      className={col1 ? 'faq position-relative text-primary' : 'faq position-relative text-dark'}
                    >
                      <CardHeader className="border-0 shadow bg-light p-3" id="headingOne">
                        <h6 className="title mb-0">
                          How do I add a new word to my list?
                          <i className={col1 ? 'mdi mdi-chevron-up float-end' : 'mdi mdi-chevron-down float-end'} />
                        </h6>
                      </CardHeader>
                    </Link>
                    <Collapse isOpen={col1}>
                      <CardBody>
                        <p className="text-muted mb-0 faq-ans">
                          Click the word you want to learn while you browse any website. Tap the HighVocab icon that appears, then click &quot;Save word&quot; on the definition card to add it to your list.
                        </p>
                      </CardBody>
                    </Collapse>
                  </Card>

                  <Card className="border-0 rounded mb-2">
                    <Link
                      to="#"
                      onClick={() => setCol5(!col5)}
                      className={col5 ? 'faq position-relative text-primary' : 'faq position-relative text-dark'}
                    >
                      <CardHeader className="border-0 shadow bg-light p-3">
                        <h6 className="title mb-0">
                          Can I see the full details of a word?
                          <i className={col5 ? 'mdi mdi-chevron-up float-end' : 'mdi mdi-chevron-down float-end'} />
                        </h6>
                      </CardHeader>
                    </Link>
                    <Collapse isOpen={col5}>
                      <CardBody>
                        <p className="text-muted mb-0 faq-ans">
                          Yes. Tap any word in your list or in Discover to open the Word Detail page. You will see the full definition, example sentences, word forms, related words, and common phrases — all in one place.
                        </p>
                      </CardBody>
                    </Collapse>
                  </Card>

                  <Card className="border-0 rounded mb-2">
                    <Link
                      to="#"
                      onClick={() => setCol2(!col2)}
                      className={col2 ? 'faq position-relative text-primary' : 'faq position-relative text-dark'}
                    >
                      <CardHeader className="border-0 shadow bg-light p-3" id="headingTwo">
                        <h6 className="title mb-0">
                          Can I see definitions for highlighted words on a webpage?
                          <i className={col2 ? 'mdi mdi-chevron-up float-end' : 'mdi mdi-chevron-down float-end'} />
                        </h6>
                      </CardHeader>
                    </Link>
                    <Collapse isOpen={col2}>
                      <CardBody>
                        <p className="text-muted mb-0 faq-ans">
                          Yes. Hover over any highlighted word on a webpage and a pop-up will show the translation, pronunciation, definition, and an example sentence right away.
                        </p>
                      </CardBody>
                    </Collapse>
                  </Card>

                  <Card className="border-0 rounded mb-2">
                    <Link
                      to="#"
                      onClick={() => setCol3(!col3)}
                      className={col3 ? 'faq position-relative text-primary' : 'faq position-relative text-dark'}
                    >
                      <CardHeader className="border-0 shadow bg-light p-3">
                        <h6 className="title mb-0">
                          What languages can I translate into?
                          <i className={col3 ? 'mdi mdi-chevron-up float-end' : 'mdi mdi-chevron-down float-end'} />
                        </h6>
                      </CardHeader>
                    </Link>
                    <Collapse isOpen={col3}>
                      <CardBody>
                        <p className="text-muted mb-0 faq-ans">
                          HighVocab is for English learners and supports translations into over 60 languages.
                        </p>
                      </CardBody>
                    </Collapse>
                  </Card>

                  <Card className="border-0 rounded mb-2">
                    <Link
                      to="#"
                      onClick={() => setCol4(!col4)}
                      className={col4 ? 'faq position-relative text-primary' : 'faq position-relative text-dark'}
                    >
                      <CardHeader className="border-0 shadow bg-light p-3">
                        <h6 className="title mb-0">
                          Can I export my word list?
                          <i className={col4 ? 'mdi mdi-chevron-up float-end' : 'mdi mdi-chevron-down float-end'} />
                        </h6>
                      </CardHeader>
                    </Link>
                    <Collapse isOpen={col4}>
                      <CardBody>
                        <p className="text-muted mb-0 faq-ans">
                          Yes. You can export your vocabulary list as a CSV file, which you can open in Microsoft Excel or any spreadsheet program.
                        </p>
                      </CardBody>
                    </Collapse>
                  </Card>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <Testi />

      <div className="position-relative">
        <div className="shape overflow-hidden text-footer">
          <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor" />
          </svg>
        </div>
      </div>

      <BackToTop />
    </React.Fragment>
  );
};

export default Index;
